import { IMG } from "@/lib/site";
import Chapter from "@/components/cinema/Chapter";
import { Reveal, LineReveal } from "@/components/cinema/Reveal";

const process = [
  { n: "01", t: "Rapid Dispatch", d: "Call our 24/7 line. A coordinator picks up and a crew is on the move within minutes." },
  { n: "02", t: "On-Site Assessment", d: "We document the loss, inventory affected contents and align with restoration contractors and adjusters." },
  { n: "03", t: "Protect & Pack-Out", d: "Belongings are carefully packed, labeled and transported to secure storage while repairs proceed." },
  { n: "04", t: "Pack-Back & Closeout", d: "Once your space is ready, we deliver, unpack and reset contents, leaving the property restored." },
];

export default function ProcessChapter() {
  return (
    <Chapter img={IMG.stageDrying} overlay="dark" testId="process">
      <div className="max-w-3xl mb-16">
        <Reveal y={16}><div className="live-pill mb-5"><span className="dot"></span> The process</div></Reveal>
        <LineReveal
          className="display-chunky text-4xl md:text-6xl xl:text-7xl leading-[0.92]"
          lines={[<>From <span className="text-[hsl(var(--gaza-crimson-bright))]">first call</span></>, "to final closeout."]}
        />
      </div>
      <div className="grid md:grid-cols-4 gap-px bg-white/10 border border-white/10">
        {process.map((p, i) => (
          <Reveal key={p.n} delay={i * 0.12} className="h-full">
            <div className="h-full bg-[hsl(var(--gaza-teal-deep))]/55 backdrop-blur-md p-8 md:p-10 group hover:bg-[hsl(var(--gaza-teal-deep))]/80 transition" data-testid={`process-step-${p.n}`}>
              <div className="mega-num text-7xl text-[hsl(var(--gaza-crimson-bright))]">{p.n}</div>
              <div className="mt-5 w-12 h-0.5 bg-[hsl(var(--gaza-crimson-bright))] group-hover:w-20 transition-all duration-500"></div>
              <h3 className="display-chunky text-2xl mt-5 mb-3 leading-tight">{p.t}</h3>
              <p className="text-white/70 leading-relaxed text-sm">{p.d}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </Chapter>
  );
}
